import { render } from "./confirmModel.vue?vue&type=template&id=8fed755e&scoped=true"
import script from "./confirmModel.vue?vue&type=script&lang=js"
export * from "./confirmModel.vue?vue&type=script&lang=js"

import "./confirmModel.vue?vue&type=style&index=0&id=8fed755e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fed755e"]])

export default __exports__